<template>
  <div class="box-wrap">
    <div class="title">评价飞手</div>
    <div class="name">
      <div class="imgs">
        <van-image :src="flyer.avatar"></van-image>
      </div>
      <div class="names">{{flyer.nickname}}</div>
      <div class="title">匿名评价</div>
    </div>
    <div class="rate-box">
      <van-rate
        v-model="value"
        color="#FF9922"
        :size="30"
        class="rates"
      />
      <div class="titles">{{rateText}}</div>
    </div>
    <div class="upload-box">
      <div class="title">
        <van-field
          v-model="message"
          class="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="你的评价会让飞手做的更好"
          show-word-limit
        />
      </div>

      <van-uploader
        :after-read="afterRead"
        :max-count="1"
        v-model="fileList"
        accept="*"
      />

    </div>
  </div>
</template>
<script>
import axios from "../../http";
import { mapState } from "vuex";
export default {
  name: "rate_box",
  components: {},
  props: {
    flyer: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      value: 0,
      message: "",
      rateText: "",
      fileList: [],
      url: "",
      mid: this.flyer.mid
    };
  },
  computed: {
    ...mapState(["token"])
  },
  watch: {
    value(newVal) {
      switch (newVal) {
        case 1:
          this.rateText = "非常差";
          break;
        case 2:
          this.rateText = "较差";
          break;
        case 3:
          this.rateText = "一般";
          break;
        case 4:
          this.rateText = "较好";
          break;
        case 5:
          this.rateText = "非常好";
          break;
      }
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    afterRead(file) {
      console.log('file :>> ', file);
      // 此时可以自行将文件上传至服务器
      let img_yz = new Image();
      var reader = new FileReader();

      // img_yz.src = file.content;
      // reader.readAsDataURL(file.file);
      // let s = this.compress(img_yz, file.file.name);

      
      new Promise ( (resolve,reject) => {
         img_yz.src = file.content;
         reader.readAsDataURL(file.file);
         setTimeout(() => {
          let s = this.compress(img_yz, file.file.name, file.file.type);
          // console.log('s :>> ', s);
          if(s.size != 0){
            resolve(s)
          }else if(s.size == 0){
            this.$toast('图片压缩失败，请尝试其他图片，或者稍后再试')
          }
         },1500)
      }).then((res) => {
          let formata = new FormData();
          formata.append("token", this.token);
          formata.append("file", res);
          this.getImgUrl(formata);
      })
    },
    getImgUrl(params) {
      axios
        .fetchPost("/member/upload/image", params)
        .then(res => {
          if (res.data.code == 200) {
            this.url = res.data.data.url;
          } else {
          }
        })
        .catch(error => {
          console.log("error :", error);
        });
    },

    compress(file, names,type) {
      // 压缩到图片原始宽高的一半
      var w = file.naturalWidth / 2;
      var h = file.naturalHeight / 2;
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var anw = document.createAttribute("width");
      anw.nodeValue = w;
      var anh = document.createAttribute("height");
      anh.nodeValue = h;
      canvas.setAttributeNode(anw);
      canvas.setAttributeNode(anh);
      ctx.fillRect(0, 0, w, h);
      ctx.drawImage(file, 0, 0, w, h);
      //可以根据base64 做相关的预览功能 这里就不演示了
      const base64 = canvas.toDataURL(type, 0.5); // 压缩后质量
      const bytes = window.atob(base64.split(",")[1]);
      const ab = new ArrayBuffer(bytes.length);
      const ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      let blob = new Blob([ab], { type: type });
      // 预览压缩后的图片
      let files = new window.File([blob], names, { type: type });
      
      return files;
    }
  }
};
</script>
<style lang="stylus" scoped>
.box-wrap
  width 95%
  padding-top 10px
  margin 0 auto
  background #ffffff
  font-family Microsoft YaHei
  text-align left
  margin-bottom 15px
  & > .title
    color #282828
    font-size 15px
    line-height 1.2
    margin 15px
    font-weight 400
  .name
    display flex
    align-items center
    margin-bottom 20px
    line-height 1.2
    .imgs
      width 40px
      height 40px
      background #55CC99
      border-radius 50%
      overflow hidden
      margin-right 15px
      margin-left 15px
    .names
      flex 1
    & > .title
      color #989898
      font-size 12px
      margin-right 10px
  .rate-box
    display flex
    margin-bottom 20px
    .rates
      flex 1
      margin-left 20px
    & > .titles
      font-size 15px
      margin-right 12px
  .upload-box
    border-top 1px solid #e5e5e5
    padding-top 15px
    padding-left 15px
    padding-bottom 15px
    & > .title
      color #C5C5C5
      font-size 13px
.submit
  width 66%
  height 40px
  text-align center
  line-height 40px
  background rgba(85, 204, 153, 1)
  border-radius 40px
  font-size 17px
  font-family Microsoft YaHei
  font-weight 400
  color rgba(255, 255, 255, 1)
  margin 20px auto
/deep/.van-uploader__preview
  /deep/.van-icon
    position absolute
</style>